function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266,
    height: 130,
    viewBox: "0 0 266 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171927",
    "data-name": "\\uADF8\\uB8F9 171927",
    transform: "translate(-288.335 -3933.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171923",
    "data-name": "\\uADF8\\uB8F9 171923",
    transform: "translate(287.863 3933.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangles",
    transform: "translate(0.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-2",
    "data-name": "Triangles",
    transform: "translate(70.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-2",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-2",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-3",
    "data-name": "Triangles",
    transform: "translate(140.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-3",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-3",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-4",
    "data-name": "Triangles",
    transform: "translate(210.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-4",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-4",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-5",
    "data-name": "Triangles",
    transform: "translate(0.472 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-5",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-5",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-6",
    "data-name": "Triangles",
    transform: "translate(70.472 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-6",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-6",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-7",
    "data-name": "Triangles",
    transform: "translate(140.472 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-7",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-7",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangles-8",
    "data-name": "Triangles",
    transform: "translate(210.472 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2-8",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M28,0,56,39H0Z",
    transform: "translate(0 19)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_3-8",
    "data-name": "\\uB2E4\\uAC01\\uD615 3",
    d: "M28,0,56,39H0Z",
    transform: "translate(56 39) rotate(180)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTriangle);
export default __webpack_public_path__ + "static/media/smallTriangle.ee541bc9de2d49db046402ef923c70ab.svg";
export { ForwardRef as ReactComponent };